module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('crud', {
    ref: "crud",
    attrs: {
      "items": _vm.items,
      "fields": _vm.authorizedFields,
      "editable": _vm.processRoleArg(_vm.editable),
      "deletable": _vm.processRoleArg(_vm.deletable),
      "refreshable": _vm.refreshable,
      "paginating": _vm.paginating,
      "perPage": _vm.perPage,
      "filtering": _vm.filtering,
      "bulk": _vm.bulk,
      "actions": _vm.actions,
      "exportable": _vm.exportable,
      "creatable": _vm.processRoleArg(_vm.creatable),
      "form-component": _vm.formComponent,
      "form-order": _vm.formOrder,
      "total": _vm.total,
      "loading": _vm.isBusy,
      "serverside": true,
      "requestAllItems": _vm.requestAllItems,
      "form-error": _vm.formError,
      "allItemsActions": _vm.allItemsActions
    },
    on: {
      "page-changed": _vm.changePage,
      "sort-changed": _vm.changeSort,
      "save": _vm.saveItem,
      "cancel": _vm.cancelItem,
      "remove": _vm.removeItems,
      "filters-changed": _vm.changeFilters,
      "refresh": _vm.refresh
    },
    scopedSlots: _vm._u([_vm._l((Object.keys(_vm.$scopedSlots)), function(slot, index) {
      return {
        key: slot,
        fn: function(row) {
          return [_c('td', {
            key: slot
          }, [_vm._t(slot, null, {
            item: row.item,
            field: row.field,
            value: row.value
          })], 2)]
        }
      }
    })])
  })
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-25f87458","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ModelCrud.vue
// module id = 1060
// module chunks = 1